export const budgetChapterFrag = `
    id
    parentId
    name
    code
    description
    parent {
        id
        name
    }
`;
